import {
  Box,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import LocalPostOfficeRoundedIcon from "@mui/icons-material/LocalPostOfficeRounded";

const useStyles = makeStyles({
  root: {
    width: "100%",
    maxWidth: 420,
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
  },
  title: {
    margin: 0,
    fontWeight: "bold",
    fontSize: "1.5em",
    color: "#050821",
    textAlign: "center",
  },
  instructions: {
    margin: "20px 0 24px",
    fontSize: "0.95rem",
    fontWeight: 500,
    color: "#555",
    textAlign: "center",
    lineHeight: 1.45,
  },
  form: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 18,
  },
  fieldGroup: {
    display: "flex",
    flexDirection: "column",
    gap: 6,
  },
  label: {
    fontSize: "0.95rem",
    fontWeight: 500,
    color: "#1A1A1A",
  },
  inputRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  mailIcon: {
    color: "#050821",
    fontSize: 28,
    flexShrink: 0,
  },
  textField: {
    width: "100%",
    backgroundColor: "#fff",
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      backgroundColor: "#fff",
      minHeight: 48,
      "& fieldset": {
        borderColor: "#C9C9C9",
      },
      "&:hover fieldset": {
        borderColor: "#9E9E9E",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#050821",
        borderWidth: 1,
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: "12px 14px !important",
      height: "24px !important",
      boxSizing: "content-box",
      fontSize: "1rem !important",
    },
  },
  buttonsRow: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    marginTop: 8,
    width: "100%",
  },
  errorText: {
    fontSize: "0.8rem",
    color: "#d32f2f",
    marginTop: 2,
  },
});

const submitButtonSx = {
  height: 48,
  flex: 1,
  minWidth: 0,
  backgroundColor: "#050821 !important",
  color: "#fff !important",
  textTransform: "none",
  fontWeight: 700,
  fontSize: "1.05rem",
  lineHeight: 1.2,
  borderRadius: "10px",
  boxShadow: "none !important",
  border: "1px solid #050821",
  padding: "0 16px",
  "&:hover": {
    backgroundColor: "#121531 !important",
    boxShadow: "none !important",
  },
};

const cancelButtonSx = {
  height: 48,
  flex: 1,
  minWidth: 0,
  backgroundColor: "#fff !important",
  color: "#050821 !important",
  textTransform: "none",
  fontWeight: 700,
  fontSize: "1.05rem",
  lineHeight: 1.2,
  borderRadius: "10px",
  boxShadow: "none !important",
  border: "1px solid #050821 !important",
  padding: "0 16px",
  "&:hover": {
    backgroundColor: "#EEF5ED !important",
    boxShadow: "none !important",
    border: "1px solid #050821 !important",
  },
};

const formSchema = yup.object().shape({
  user: yup.string().required("Digite o email").email("E-mail inválido"),
});

export const SentResetToEmail = ({
  emailReset,
  handleReset,
  setEmailReset,
  handleCancel,
}) => {
  const {
    register,
    handleSubmit,
    setFocus,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
  });

  const classes = useStyles();

  const handleChangeEmailReset = (e) => {
    setFocus("user");
    setEmailReset(e.target.value);
  };

  return (
    <div className={classes.root}>
      <h2 className={classes.title}>Recuperação de Senha</h2>
      <p className={classes.instructions}>
        Informe o e-mail de cadastro e enviaremos as instruções para a
        reinicialização de sua senha.
      </p>

      <form className={classes.form} onSubmit={handleSubmit(handleReset)}>
        <input type="hidden" value="something" />

        <Box className={classes.fieldGroup}>
          <Typography
            component="label"
            htmlFor="outlined-email-reset-input"
            className={classes.label}
          >
            Email
          </Typography>
          <Box className={classes.inputRow}>
            <LocalPostOfficeRoundedIcon className={classes.mailIcon} />
            <TextField
              id="outlined-email-reset-input"
              className={classes.textField}
              type="text"
              placeholder="Email"
              value={emailReset.value}
              {...register("user")}
              error={!!errors.user}
              autoComplete="current-email"
              onChange={(e) => handleChangeEmailReset(e)}
            />
          </Box>
          {errors.user?.message ? (
            <Typography className={classes.errorText}>
              {errors.user.message}
            </Typography>
          ) : null}
        </Box>

        <Box className={classes.buttonsRow}>
          <Button
            type="button"
            variant="outlined"
            disableElevation
            onClick={() => handleCancel()}
            sx={cancelButtonSx}
          >
            Cancelar
          </Button>
          <Button
            type="submit"
            variant="contained"
            disableElevation
            sx={submitButtonSx}
          >
            Enviar
          </Button>
        </Box>
      </form>
    </div>
  );
};
